import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class ClientSuperAdminService {
  private baseUrl = `${environment.apiUrl}/api`;
  constructor(private http: HttpClient) {}
  private getHeaders(): HttpHeaders {
    const token = localStorage.getItem('token');
    return new HttpHeaders({
      Authorization: `Bearer ${token}`,
      
    });
  }
  getTenants(): Observable<any> {
    return this.http.get(`${this.baseUrl}/tenant`, { headers: this.getHeaders() });
  }
}
